import React from 'react';
import './lastnavfooter.css'

const Lastnavsfooter = (props) => {
    return ( 
        <li className='last-navs-footer'>{props.title}</li>
     );
}
 
export default Lastnavsfooter;